(() => {
  const menuOpeners = document.querySelectorAll('[data-mobile-menu-open]');

  menuOpeners.forEach((opener) => {
    const dialogId = opener.getAttribute('aria-controls');
    const dialog = document.getElementById(dialogId);

    if (!dialog || typeof dialog.showModal !== 'function') return;

    opener.addEventListener('click', () => {
      dialog.showModal();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      opener.focus();
    });
  });
})();

(() => {
  const predictiveSearches = document.querySelectorAll('predictive-search');

  predictiveSearches.forEach((component) => {
    const input = component.querySelector('input[type="search"]');
    const results = component.querySelector('[role="listbox"]');
    const endpoint = component.dataset.predictiveSearchUrl;
    let requestController;
    let debounceTimer;

    if (!input || !results || !endpoint) return;

    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const openResults = (html) => {
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const getOptions = () => Array.from(results.querySelectorAll('[role="option"]'));

    const fetchSuggestions = async (term) => {
      if (requestController) requestController.abort();
      requestController = new AbortController();

      const parameters = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,article,page',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });

      try {
        const response = await fetch(`${endpoint}?${parameters.toString()}`, {
          signal: requestController.signal,
        });

        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = documentFragment.querySelector('#shopify-section-predictive-search');

        if (section && section.innerHTML.trim()) {
          openResults(section.innerHTML);
        } else {
          closeResults();
        }
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      const term = input.value.trim();

      if (term.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = window.setTimeout(() => fetchSuggestions(term), 180);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults();
        return;
      }

      if (event.key === 'ArrowDown' && !results.hidden) {
        const firstOption = getOptions()[0];
        if (firstOption) {
          event.preventDefault();
          firstOption.focus();
        }
      }
    });

    results.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return;

      event.preventDefault();
      if (event.key === 'Escape') {
        closeResults();
        input.focus();
        return;
      }

      const options = getOptions();
      const currentIndex = options.indexOf(document.activeElement);
      const nextIndex = event.key === 'ArrowDown'
        ? Math.min(currentIndex + 1, options.length - 1)
        : currentIndex <= 0
          ? -1
          : currentIndex - 1;

      if (nextIndex === -1) input.focus();
      else options[nextIndex]?.focus();
    });

    component.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!component.contains(document.activeElement)) closeResults();
      }, 0);
    });
  });
})();
